const ADD_ACCOUNT = "ADD_ACCOUNT";
const DELETE_ACCOUNT = "DELETE_ACCOUNT";
const ACCOUNTS = "ACCOUNTS";
const ADD_ACCOUNT_ERROR = "ADD_ACCOUNT_ERROR";
const ACCOUNT_DETAILS = "ACCOUNT_DETAILS";

export {
  ADD_ACCOUNT,
  DELETE_ACCOUNT,
  ACCOUNTS,
  ADD_ACCOUNT_ERROR,
  ACCOUNT_DETAILS,
};
